// extracted by mini-css-extract-plugin
module.exports = {"heading":"HomeHeading_heading__KUF5N","heading__title":"HomeHeading_heading__title__VIyO1","heading__subtitle":"HomeHeading_heading__subtitle__b49Im"};